import ClientesScreen from "../pages/ClientesScreen";
import Home from "../pages/Home";

import {
  IconHome,
  IconUsers,
  IconBuilding,
  IconFileExport,
  IconFileImport,
  IconFileDollar,
  IconMessage2,
} from "@tabler/icons-react";
import UsuariosScreen from "../pages/UsuariosScreen";
import { BLImportScreen } from "../pages/BLImportScreen";
import BLExportScreen from "../pages/BLExportScreen";
import CotizacionesPage from "../pages/CotizacionesScreen";
import ReservasPage from "../pages/ReservasPage";

interface routeType {
  path: string;
  title: string;
  screen?: () => JSX.Element;
  icon: JSX.Element;
  roles: string[];
  children?: routeType[];
  showBadge?: boolean;
}

export const screenRoutes: routeType[] = [
  {
    path: "/home",
    title: "Home",
    screen: Home,
    icon: <IconHome />,
    roles: ["1", "2"],
  },
  {
    path: "/usuarios",
    title: "Usuarios",
    screen: UsuariosScreen,
    icon: <IconUsers />,
    roles: ["1"],
  },
  {
    path: "/empresas",
    title: "Empresas",
    screen: ClientesScreen,
    icon: <IconBuilding />,
    roles: ["1"],
  },
  {
    path: "/bl-export",
    title: "BL Export",
    screen: BLExportScreen,
    icon: <IconFileExport />,
    roles: ["1", "2"],
  },
  {
    path: "/bl-import",
    title: "BL Import",
    screen: BLImportScreen,
    icon: <IconFileImport />,
    roles: ["1", "2"],
  },
  {
    path: "/cotizaciones",
    title: "Cotizaciones",
    icon: <IconFileDollar />,
    roles: ["1"],
    children: [
      {
        path: "/costos",
        title: "Costos",
        screen: CotizacionesPage,
        icon: <IconFileDollar />,
        roles: ["1"],
      },
      {
        path: "/reglas",
        title: "Reglas",
        screen: CotizacionesPage,
        icon: <IconFileDollar />,
        roles: ["1"],
      },
    ],
  },
  {
    path: "/reservas",
    title: "Reservas",
    icon: <IconMessage2 />,
    screen: ReservasPage,
    showBadge: true,
    roles: ["1"],
  },
];
